import { useState } from "react";
import type { GridPageChangeEvent } from "@progress/kendo-react-grid";

const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZES = [10, 20, 50];

/**
 * Shared skip/pageSize state + Kendo `DataGrid` paging wiring for search-results grids (Bug
 * 158593: every search page's grid needs a page-size selector, not just prev/next). Each search
 * page previously duplicated this as a fixed `const PAGE_SIZE` + bare `skip` state - this
 * consolidates it into one place so the fix doesn't have to be repeated per page.
 */
export function usePagedGrid(initialPageSize = DEFAULT_PAGE_SIZE) {
  const [skip, setSkip] = useState(0);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const pageNumber = Math.floor(skip / pageSize) + 1;

  const onPageChange = ({ page }: GridPageChangeEvent) => {
    setSkip(page.skip);
    setPageSize(page.take);
  };

  const resetPaging = () => setSkip(0);

  return {
    skip,
    pageSize,
    pageNumber,
    pageable: { pageSizes: PAGE_SIZES },
    onPageChange,
    resetPaging,
  };
}
